import { CardContent, CardHeader, Grid2, Stack } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import MaterialTypography from "../../../components/MaterialTypography"
import MaterialButton from "../../../components/MaterialButton"
import { useDispatch, useSelector } from "react-redux"
import { Add, FilterAlt } from "@mui/icons-material"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useSnackbar } from "../../../context/popup"
import { useLoading } from "../../../components/Loading"
import MaterialSelect from "../../../components/MasterSelect"
import { setCurrentPage, setRowsPerPage, setSelectedCategory, setTotalPages } from "./store/healthKeyValueStore.js";
import Table from "../../../components/Table/index.js"
import { deleteData, fetchData } from "../../../services/index.js"
import HealthStoreFilterDialog from './components/HealthStoreFilterDialog.js';

const HealthStoreList = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();
     const currentPage = useSelector(
      (state) => state?.healthKeyValueStore?.currentPage
    );
    const rowsPerPage = useSelector(
      (state) => state?.healthKeyValueStore?.rowsPerPage
    );
    const totalPages = useSelector(
      (state) => state?.healthKeyValueStore?.totalPages
    );
    const selectedCategory = useSelector((state) => state?.healthKeyValueStore?.selectedCategory) || null;

    const [keyValueData, setKeyValueData] = useState([]);
    const [operationCategoryOptions, setOperationCategoryOptions] = useState([]);
    const [isRefresh, setIsRefresh] = useState(false);
    const [search, setSearch] = useState("");
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [filterData, setFilterData] = useState({
        isActive: "",
        parentKeyId: ""
    });

    useEffect(() => {
        fetchHealthStoreList(selectedCategory?.value);
    },[isRefresh, currentPage, rowsPerPage, search])

    useEffect(() => {
        fetchHealthCategoryData();
    }, []);

    //fetch category dropdown
    const fetchHealthCategoryData = async () => {
        try {
        const response = await fetchData(`/reference/health/key-value-category`);
        
        if (response?.success) {
            setOperationCategoryOptions(response?.data?.items.map((item) => ({
                value: item.id,
                label: item.categoryName
            })));
        }
        } catch (error) {
        console.error("Error fetching data:", error);
        showSnackbar(error?.response?.data?.message || "Network Error", "error");
        }
    };

    //List API
    const fetchHealthStoreList = async (categoryId) => {
        setCircleLoading(true);
        try {
            let url = `/reference/health/key-value-store?page=${currentPage}&limit=${rowsPerPage}&searchTerm=${search}&categoryId=${categoryId || ""}`;
                                    
            //filter
            if(filterData.isActive !== "") {
                url += `&isActive=${filterData.isActive}`;
            }
            if(filterData.parentKeyId !== "") {
                url += `&parentKeyId=${filterData.parentKeyId}`;
            }
            const response = await fetchData(url);
            if(response?.success){
                setKeyValueData(response?.data?.items);
                dispatch(setTotalPages(response?.data?.totalPages));
            }
        } catch (error) {
            console.error("Error in fetching Key value Store");
            showSnackbar(error?.response?.data?.message || "Error in fetching Key value Store","error");
        } finally {
            setCircleLoading(false);
        }
    };

    //delete api function
    const handleDelete = async (row) => {
        try {
            const response = await deleteData(`/reference/health/key-value-store-delete`, {ids:[row?.id]});
            setIsRefresh(!isRefresh);
            if(response?.success){
                showSnackbar(response?.message, "success");
            }
            else{
                showSnackbar(response?.message, "error");
            }
        } catch (error) {
            console.error("Error deleting data:", error);
            showSnackbar(error?.response?.data?.message || "Error deleting data", "error");
        }
    };

    const handleCategoryChange = async (event) => {
        setCircleLoading(true);
        fetchHealthStoreList(event?.value);
        dispatch(setSelectedCategory(event));
    };

    //table mapping
    const healthStoreTable = {
        columns : [
        {
        key: "sno",
        label: "S.No",
        renderCell: (row) => row.sno,
        },
        {
        key: "code",
        label: "Code",
        renderCell: (row) => row.category.code,
        },
        {
        key: "keyName",
        label: "Key Name",
        renderCell: (row) => row.keyName,
        },
        {
        key: "category",
        label: "Category",
        renderCell: (row) => row.category?.categoryName,
        },
        {
        key: "createdAt",
        label: "Created At",
        renderCell: (row) => row.createdAt,
        },
        {
        key: "active",
        label: "Status",
        renderCell: (row) => (
            <span>
            {row.isActive ? (
                <span style={{ color: "green", fontWeight: "bold" }}>Active</span>
            ) : (
                <span style={{ color: "red", fontWeight: "bold" }}>Inactive</span>
            )}
            </span>
        ),
        },
    ],

    rows : keyValueData.map((keyValue, index) => ({
        ...keyValue,
        sno: index + 1,
        createdAt: new Date(keyValue.createdAt).toLocaleDateString("en-GB"),
    }))
    };

    const actions = {
        edit: true,
        view: true,
        delete: true,
        onEdit: (row) =>
            navigate(`/health-master/health-store/store-details/?pageType=edit&id=${row?.id}`,
            {   state: {
                    categoryId: selectedCategory?.value,
                    categoryName: selectedCategory?.label,
                },
            }),
        onView: (row) =>
            navigate(`/health-master/health-store/store-details/?pageType=view&id=${row?.id}`,
            {   state: {
                    categoryId: selectedCategory?.value,
                    categoryName: selectedCategory?.label,
                },
            }),
        onDelete: (row) => handleDelete(row),
    };

    const handlePaginationChange = (page) => {
        dispatch(setCurrentPage(page));
    };
    
    const handleRowsPerPageChange = (rowsPerPage) => {
        dispatch(setRowsPerPage(rowsPerPage));
        dispatch(setCurrentPage(1));
    };

    const handleSearch = (value) => {
        setSearch(value);
    };

    const handleAddNewKeyValue = () => {
      navigate("/health-master/health-store/store-details", {
      state: { categoryId: selectedCategory?.value, categoryName: selectedCategory?.label },
      });
    };
     
  return (
    <DashboardLayout>
        <CardHeader title={(
            <Stack
            direction={{ xs: "column", sm: "row" }}
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            >
                <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                        Health Key Value Store List
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                        List of Health Key Value Stores of Respective Category, select a category to list its Key-Value-Stores.
                    </MaterialTypography>
                </Stack>
                {selectedCategory?.value && (
                <Stack direction="row" spacing={1}>
                  <MaterialButton
                  variant="gradient"
                  color="dark"
                  size="small"
                  startIcon={<FilterAlt/>}
                  onClick={(event) => setAnchorEl(event.currentTarget)}
                  >
                  Filter
                  </MaterialButton>
                    <MaterialButton
                        variant="gradient"
                        color="dark"
                        size="small"
                        startIcon={<Add />}
                        onClick={() => handleAddNewKeyValue()}
                    >
                        Add {selectedCategory?.label}
                    </MaterialButton>
                </Stack>
                )}
            </Stack>
            )} 
        />
        <Grid2 container spacing={2} alignItems="center" sx={{ mx: 2 }}>
            <Grid2 size={{ xs: 12, sm: 3 }}>
            <MaterialSelect
                name="categoryName"
                value={selectedCategory}
                customStyles={{ optionPadding: 20 }}
                onChange={handleCategoryChange} //selectedValue, event
                options={operationCategoryOptions?.map((item) => {
                return {
                    value: item.value,
                    label: item.label,
                };
                })}
                success={selectedCategory?.value}
            />
            </Grid2>
        </Grid2>
        <CardContent>
            <Table
            columns={healthStoreTable?.columns}
            data={healthStoreTable?.rows}
            actions={actions}
            pagination={{
                totalPages,
                currentPage,
                onPageChange: (page) => handlePaginationChange(page),
                rowsPerPage,
                onRowsPerPageChange: (rowsPerPage) => handleRowsPerPageChange(rowsPerPage),
                rowsPerPageOptions: [5, 10, 15, 20],
            }}
            getRowKey={(row) => row.id}
            className="custom-table"
            noDataLabel={"No Key Value data found"}
            handleSearch={handleSearch}
            />
        </CardContent>
        <HealthStoreFilterDialog
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        filterData={filterData}
        setFilterData={setFilterData}
        onApply={() => {
            setAnchorEl(null);   // close popup
            fetchHealthStoreList(selectedCategory?.value);  // call API after filter applied
        }}
        />
    </DashboardLayout>
  )
}

export default HealthStoreList